import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./view/App";
import "./i18n";
import "./index.css";

const rootEl = document.getElementById("root") as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap pre-renders pages in production — hydrate if SSR content exists
if (process.env.NODE_ENV === "production" && rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
